import 'bootstrap.collapse';
import { registerComponents } from 'component-utils';
import components from 'core-components';
import 'global';

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    // Register the components (if applicable).
    if (context instanceof Document && config.registerComponents !== false)
        registerComponents(components);

    const current = context.querySelector('#right-column .widget li a[href="' + window.location.pathname.toLowerCase() + '"]');

    if (current != null)
        current.parentElement.classList.add('active');
}